import { parsePhoneNumberFromString, isValidPhoneNumber } from 'libphonenumber-js';

export function getPaymentErrorMessage(checkoutError, messages) {
    switch (checkoutError) {
        case 'CANCELLED':
            return messages.errors.paymentCancelled()
        case 'ERR_INVALID_CARD_TYPE':
            return messages.errors.cardNotSupported()
        default:
            return messages.errors.paymentFailed()
        }
}

export function validateKlarnaPhoneNumber(savedAddress, billingAddress) {
    if(typeof Number(billingAddress.addressId) !== 'number') return
    const address = savedAddress.filter((address) => Number(address.addressId) === Number(billingAddress.addressId))[0]
    if (address && !address.transient) {
        return isValidPhoneNumber(address.phone1)        
    } 
    return true
}